import * as React from 'react'
import { connect } from 'react-redux'
import { noop } from 'lodash'
import { RouteComponentProps } from 'react-router-dom'

import NavBar from '@doordash/component-navbar'
import Separator from '@doordash/component-separator'
import { Text, Colors, Inset, StackChildren } from '@doordash/design-language'

import { getDasherCountry } from '../../../../selectors/deliveryIssues'
import { loadUrl } from '../../../../webview'
import routes from '../../../../routes'
import ListCellMenuItem from '../components/ListCellMenuItem'
import { getDeactivationPolicyUrl } from '../utilities'
import {
  CRITICAL_DELIVERY_ISSUES_FAQ_URL,
  CUSTOMER_IS_UNAVAILABLE_FAQ_URL,
} from '../constants'
import { DasherCountries } from '../types'
import t from './strings'

type ExplanationProps = {
  country: DasherCountries
}

const Explanation: React.FC<RouteComponentProps & ExplanationProps> = ({
  history,
  country,
}) => {
  return (
    <div>
      <NavBar
        isSeparatorVisible={false}
        navigationType={NavBar.NavigationTypes.Close}
        onNavigationClick={() => history.goBack()}
        onOverflowClick={noop}
      />
      <Inset>
        <StackChildren>
          <Text styles={Text.Styles.Bold24}>{t.title()}</Text>
          <Text
            styles={Text.Styles.PageDescriptionBody}
            color={Colors.SystemGrey60}
          >
            {t.body()}
          </Text>
        </StackChildren>
      </Inset>
      <Separator type={Separator.Types.FullBorder} />
      <div role="list">
        <ListCellMenuItem
          title={t.deactivationPolicy()}
          onClick={() => loadUrl(getDeactivationPolicyUrl(country))}
        />
        <ListCellMenuItem
          title={t.customerUnavailableFaq()}
          onClick={() => loadUrl(CUSTOMER_IS_UNAVAILABLE_FAQ_URL)}
        />
        <ListCellMenuItem
          title={t.criticalDeliveryIssuesFaq()}
          onClick={() => loadUrl(CRITICAL_DELIVERY_ISSUES_FAQ_URL)}
        />
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  country: getDasherCountry(state),
})

export default connect(mapStateToProps, null)(Explanation)
